 
import FalconCardHeader from '@/components/common/FalconCardHeader';
import HelpTooltip from '@/app/common/components/HelpTooltip';
import { Card, Col, Row, Spinner } from 'react-bootstrap';

type CardSkeletonProps = {
  data?: unknown;
};

const CardSkeleton = (_props: CardSkeletonProps) => (
  <Card className="h-100 overflow-hidden">
    <FalconCardHeader
      title={
        <div>
          درحال بارگذاری
          <HelpTooltip html="درحال بارگذاری" />
        </div>
      }
      titleTag="h6"
      className="py-2"
      light
    />
    <Card.Body className="py-3">
      <Row className="justify-content-center align-items-center h-100 g-0">
        <Col xs="auto">
          {/* <div className="ps-0">
              <Placeholder
                as="span"
                style={{ height: 50, width: 50, borderRadius: '50%' }}
              />
            </div> */}
          <Spinner style={{ width: 100, height: 100, borderWidth: 8 }} />
        </Col>
      </Row>
    </Card.Body>
  </Card>
);
export default CardSkeleton;
